import img1 from '../images/programImages/1.jpg';
// import img2 from '../images/programImages/2.jpg';
// import img3 from '../images/programImages/3.jpg';
// import img4 from '../images/programImages/4.jpg';
// import img5 from '../images/programImages/5.jpg';




const ProgramData=[
    {
        programImage:img1,
        title:"कोरोना सम्भधी सचेतना",
        description:"एशिया प्रशान्त क्षेत्रको विभिन्न नगरपालिका र अन्य सरोकारवाल  संस्थाहरुको संजाल सिटी नेटको ३८ औं कार्यसमिति बैठक तथा सम्पदा तथा दिगो पर्यटन  विषयक सेमिनारको उद्घाटन कार्यक्रममा मन्तब्य राख्नु हुदै सम्माननीय उपराष्ट्रपति नन्द बहादुर पुनज्यू"

    },
    // {
    //     programImage2:img2,
    //     title2:"Covid-Program",
    //     description2:"एशिया प्रशान्त क्षेत्रको विभिन्न नगरपालिका र अन्य सरोकारवाल  संस्थाहरुको संजाल सिटी नेटको ३८ औं कार्यसमिति बैठक तथा सम्पदा तथा दिगो पर्यटन  विषयक सेमिनारको उद्घाटन कार्यक्रममा मन्तब्य राख्नु हुदै सम्माननीय उपराष्ट्रपति नन्द बहादुर पुनज्यू"

    // },
    // {
    //     programImage3:img3,
    //     title3:"Covid-Program",
    //     description3:"एशिया प्रशान्त क्षेत्रको विभिन्न नगरपालिका र अन्य सरोकारवाल  संस्थाहरुको संजाल सिटी नेटको ३८ औं कार्यसमिति बैठक तथा सम्पदा तथा दिगो पर्यटन  विषयक सेमिनारको उद्घाटन कार्यक्रममा मन्तब्य राख्नु हुदै सम्माननीय उपराष्ट्रपति नन्द बहादुर पुनज्यू"

    // },
    // {
    //     programImage4:img4,
    //     title4:"Covid-Program",
    //     description4:"एशिया प्रशान्त क्षेत्रको विभिन्न नगरपालिका र अन्य सरोकारवाल  संस्थाहरुको संजाल सिटी नेटको ३८ औं कार्यसमिति बैठक तथा सम्पदा तथा दिगो पर्यटन  विषयक सेमिनारको उद्घाटन कार्यक्रममा मन्तब्य राख्नु हुदै सम्माननीय उपराष्ट्रपति नन्द बहादुर पुनज्यू"

    // }
]
export default ProgramData;

// ProgramData.map((value)=>{
//     return(
//     <Program title={value.title}
//     description={value.description}
//     image={value.programImage}
//     />

//     )

//        })

//      }